export default "__VITE_ASSET__c8696d5f__"